import type { ReactNode } from 'react'

// Mesmo molde que o app já usa para sucesso (emerald) e aviso (amber) --
// borda, título e descrição -- só que o erro tinha ficado para trás, ainda
// como texto vermelho cru. Achado da revisão de segurança de 04/09/2026:
// nunca passar o texto técnico do banco pro título/mensagem; sempre uma
// explicação genérica do que aconteceu.
export default function CartaoErro({
  titulo,
  children,
  aoTentarNovo,
}: {
  titulo: string
  children: ReactNode
  aoTentarNovo?: () => void
}) {
  return (
    <div role="alert" className="bg-red-50 border border-red-200 rounded-xl p-4 flex gap-2.5 items-start">
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-5 h-5 shrink-0 mt-0.5 text-red-800"
      >
        <circle cx="12" cy="12" r="9" />
        <line x1="12" y1="8" x2="12" y2="13" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      <div className="min-w-0">
        <h4 className="font-medium text-red-800 text-sm">{titulo}</h4>
        <p className="text-sm text-red-700 mt-0.5">{children}</p>
        {aoTentarNovo && (
          <button
            type="button"
            onClick={aoTentarNovo}
            className="mt-1.5 text-sm font-medium text-red-800 underline"
          >
            Tentar de novo
          </button>
        )}
      </div>
    </div>
  )
}
